










































import {Mixins, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import authorityContentTop from '@/components/authority/authorityContentTop.vue';
import {i18nInObjectList} from '@/utils/i18n';
import GroupsListColumns from '@/components/authority/mixins/groupsListColumns';
import {RadioRenderer} from '@/utils/commonUtils';
import {ncpPopup} from '@/utils/commonUtils';
import {changeDateFormat} from '@/utils/dateUtils';
import {writeExcel} from '@/utils/excel';
import $ from 'jquery';
import ReasonDetailLayerPopup from '@/components/ReasonDetailLayerPopup.vue';
import { AuthorityGroup } from 'ncp-api-supporter';

@Component({
  components: {
    PageTitle,
    ItemTable,
    authorityContentTop,
    ReasonDetailLayerPopup
  }
})
export default class GroupList extends Mixins(GroupsListColumns) {
  private totalCount: number = 0;
  private initPageSize: number = 30;
  private groupsListContent: any = null;

  private option: any = {
    theExcelDownIfo: null as any
  };
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {}
  };
  private listColumns: string[] = ['선택', '권한그룹명', '권한그룹설명', '권한보유자', '개인정보목록조회', '상품담당자', '등록자', '등록일시', '최종수정자', '최종수정일시'];

  private gridProps: any = {
    options: {
      header: {
        height: 32,
        bacground: '#ccc'
      },
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      displayRowCount: 30,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    columnOptions: {
      useFormattedValue: true
    },
    showDummyRows: true,
    columns: []
  };
  private size: number = 30;
  private requset: any = {
    params: {
      pageSize: 30,
      page: 1,
      name: ''
    }
  };

  private reasonDetailModal = { isOpen: false, reasonDetail: '' };

  private closeReasonDetailModal() {
    this.reasonDetailModal.isOpen = false
  }

  private openReasonDetailModal() {
    const checkedRows = (this.$refs.itemTable as any).getCheckedRows() as AuthorityGroup[];

    if (!checkedRows.length) {
      alert(this.$t('AUTHORITY_GROUPLIST_DELETEGROUPS_UNCHECKED'));

      return;
    }

    if (checkedRows[0].adminCount) {
      alert('운영자가 등록된 권한그룹은 삭제할 수 없습니다.');

      return;
    }

    this.reasonDetailModal.isOpen = true;
  }

  private confirmReasonDetailModal(value: string) {
    this.reasonDetailModal.reasonDetail = value;

    if (!this.reasonDetailModal.reasonDetail) {
      alert('사유를 입력해주세요.');

      return;
    }

    this.closeReasonDetailModal();
    this.deleteGroups();
  }

  private created(): void {
    this.initGrids();
  }

  private searchSize(page: number = 1, size?: number): void {
    const searchVal = sessionStorage.getItem('searchVal'); 
    // 判断size是否改变，改变重新赋值size，page
    if (size) {
      //this.requset.params.perPage = size;
      this.requset.params.pageSize = size;
      this.requset.params.page = page;
      this.size = size;
      this.handleRequest(searchVal);
    } else {
      // size没改变（默认值undefined）重新赋值page， size使用初始化定义的值
      this.requset.params.page = page;
      this.handleRequest(searchVal);
    }

    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = this.size;
  }
  private initGrids(): void {
    this.listColumns.forEach((item: any) => {
      let key: any;
      for (key in this.groupsListColumns) {
        if (item === key) {
          this.gridProps.columns.push(this.groupsListColumns[key]);
        }
      }
    });
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridProps.options.rowHeaders = [
      {
        name: 'radioBtn',
        type: 'radio',
        header: '선택', // 선택
        renderer: RadioRenderer
      }
    ];
    this.initExcelColums();
  }
  private initExcelColums(): void {
    const columns: any = this.gridProps.columns.map((item: any) => {
      return item.name;
    });
    columns.forEach((el: any): any => {
      this.theExcelDownIfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.theExcelDownIfo.formatters = this.excelDownInfo.formatters;
    this.theExcelDownIfo.fileName = 'authority_group';
    this.getOption();
  }
  private handleRequest(name: any): void {
    if (name !== this.requset.params.name) {
      this.requset.params.page = 1;
      this.gridProps.options.pageOptions.page = 1;
    }
    this.requset.params.name = name;
    this.$api.getAuthorityGroups(this.requset).then((res: any) => {
      this.totalCount = res.data.totalCount;
      this.groupsListContent = res.data.contents;
    });
  }
  private getOption(): void {
    this.theExcelDownIfo.nameDateFormat = 'YYYYMMDD_HHmmss';
    this.option.excelDownInfo = this.theExcelDownIfo;
    this.option.haveConfigBtn = true;
    this.option.haveExcelDownBtn = false;
    Object.assign(this.option, this.option);
  }
  private getCheckedItems(propName: string): string {
    return (this.$refs.itemTable as any).getCheckedItems(propName);
  }
  private deleteGroups(): any {
    if (window.confirm(this.$t('AUTHORITY_GROUPLIST_DELETEGROUPS_ARE_YOU_SURE') as string)) {
      const deleteId = (this.$refs.itemTable as any).getCheckedItems('no').toString();

      this.$api.deleteAuthorityGroupsByGroupNo({ 
        pathParams: { 
          authorityGroupNo: deleteId
        }, 
        params: { 
          reasonDetail: this.reasonDetailModal.reasonDetail
        }
      })
      .then(() => {
        alert(this.$t('AUTHORITY_GROUPLIST_PERMISSION_GROUP_HAS_BEEN_DELETED'));
        this.handleRequest('');
        this.$router.push('/authorityGroup/list');
      });

      return true;
    } else {
      return false;
    }
  }
  private updateGroups(): void {
    if (!(this.$refs.itemTable as any).getCheckedItems('no')) {
      alert(this.$t('AUTHORITY_GROUPLIST_UPDATEGROUPS_UNCHECKED'));
    } else {
      this.$router.push(`/authorityGroup/addForm?authorityGroupNo=${(this.$refs.itemTable as any).getCheckedItems('no')}`);
    }
  }
  private mounted(): void {
    $('body').on('click', '.group-name-grid', $.proxy(this.clickAdminNoInGrid, this));
  }
  private destroyed(): void {
    $('body').off('click', '.group-name-grid', $.proxy(this.clickAdminNoInGrid, this));
  }
  private clickAdminNoInGrid(ev: any) {
    const memberno = $(ev.target).data('index');
    ncpPopup(`/authorityGroup/popup?authorityGroupNo=${memberno}`, this.$t('AUTHORITY_GROUPLIST_QUERY_OPERATORS_WITH_PERMISSION') as string, 780, 540);
  }
  private async excelDown() {
    const req: any = { params: {name: this.requset.params.name, pageSize: this.totalCount}};
    const res =  await this.$api.getAuthorityGroups(req);
    const excMembers = res.data.contents;
    const filename = 'authority_group_' + changeDateFormat(new Date(), 'YYYYMMDD_HHmmss');
    writeExcel(excMembers, this.excelDownInfo.columns, filename, this.excelDownInfo.formatters);

    await this.$api.postPrivacyAccessHistories({
      data: {
        menu: 'AUTHORITY_MANAGE',
        workingType: 'DOWNLOAD',
      },
    } as any);
  }
}
